// extracted by mini-css-extract-plugin
module.exports = {"root":"Title_root__rCRId","title":"Title_title__G2uO6","logo":"Title_logo__up6zr"};